import React from 'react';
import './WhatsAppButton.css';
import { FaWhatsapp } from "react-icons/fa";
const WhatsAppButton = ({ phoneNumber, message }) => {
  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <button className="whatsapp-button" onClick={handleClick}>
      <i className="ion"><FaWhatsapp /></i>
    </button>
  );
};

export default WhatsAppButton;
